import React, { useCallback, useEffect, useMemo } from "react";
import { useIntl } from "react-intl";
import { Button } from "reactstrap";
import { useMeCore } from "../../../../cores/me";
import { useYoutubeCore, isYoutubeConnected } from "../../../../cores/youtube";

const YoutubeAuthButton = () => {
  const intl = useIntl();
  const { company, getMeSocialSettings } = useMeCore();
  const { get, settings, unbind, login } = useYoutubeCore();

  useEffect(() => {
    if (company?.id) get(String(company.id));
  }, [company, get]);

  const isActive = useMemo(() => isYoutubeConnected(settings), [settings]);

  const handleBind = useCallback(async () => {
    if (!company?.id) return;
    const loginUrl = await login(String(company.id));
    if (loginUrl) window.open(loginUrl, "_self");
  }, [company, login]);

  const handleUnbind = useCallback(async () => {
    if (!company?.id) return;
    await unbind(String(company.id), () => {
      getMeSocialSettings(company.id);
    });
  }, [unbind, company, getMeSocialSettings]);

  return (
    <Button
      className="w-100 mx-auto"
      color="danger"
      outline={isActive}
      onClick={!isActive ? handleBind : handleUnbind}
    >
      {!isActive
        ? intl.formatMessage({ id: "app.home.syncUp" })
        : intl.formatMessage({ id: "app.home.disconnect" })}
    </Button>
  );
};

export default YoutubeAuthButton;
